// extracted by mini-css-extract-plugin
export default {"container":"LX-z","title":"MX-z","link":"NX-z"};